export enum EShareMode {
  ANYONE = 'anyone',
  REQUIRE_LOGIN = 'require_login',
  TEAM_ONLY = 'team_only',
  TEAM_ONLY_ALLOW_JOIN = 'team_only_allow_join',
  NO_ONE = 'no_one',
}
